import { defineMessages } from 'react-intl';

export const errorMessages = defineMessages({
  TOO_MANY_REQUESTS: {
    defaultMessage: 'Vous avez atteint la limite de requêtes. Veuillez réessayer plus tard.',
  },
});
